import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "table-card" }
const _hoisted_2 = {
  "data-test": "table-card-head",
  class: "table-card__head"
}
const _hoisted_3 = { class: "table-card__title" }
const _hoisted_4 = {
  key: 0,
  "data-test": "table-card-aside",
  class: "table-card__aside"
}
const _hoisted_5 = {
  key: 1,
  class: "table-card__actions"
}
const _hoisted_6 = {
  key: 0,
  "data-test": "table-card-foot",
  class: "table-card__foot"
}


export default {
  __name: 'RecordTableCard',
  props: {
  title: { type: String, required: true },
  aside: { type: String, default: '' }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1),
      (__props.aside)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.aside), 1))
        : _createCommentVNode("", true),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}